import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import WhyWeExist from "@/components/WhyWeExist";
import WhatWeBuild from "@/components/WhatWeBuild";
import WhoWeAre from "@/components/WhoWeAre";
import HowWePartner from "@/components/HowWePartner";
import Team from "@/components/Team";
import Connect from "@/components/Connect";
import Footer from "@/components/Footer";
import AidaWidget from "@/components/AidaWidget";

function App() {
  const [aidaOpen, setAidaOpen] = useState(false);
  const [section, setSection] = useState("home");

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    const ids = ["home", "why", "build", "who", "partner", "team", "connect"];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setSection(e.target.id);
        });
      },
      { rootMargin: "-45% 0px -45% 0px", threshold: 0 }
    );
    ids.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  const openAida = () => setAidaOpen(true);

  return (
    <div className="App relative bg-gradient-to-b from-[#F7FCFD] via-[#F1FAFB] to-[#EDF8F8] text-[#0B2429]">
      <div className="grain" />
      <Navbar onAida={openAida} />
      <main>
        <Hero onAida={openAida} />
        <WhyWeExist />
        <WhatWeBuild />
        <WhoWeAre />
        <HowWePartner />
        <Team />
        <Connect onAida={openAida} />
      </main>
      <Footer />
      <AidaWidget open={aidaOpen} onClose={() => setAidaOpen(false)} section={section} />
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
